<div class="mb-promo">
    <HeaderComponent
            :path-image-bck="'base'"
            :visual="true"
    />
    <main>
        <section class="carta-del-mulino-list">
            <div class="wide-content-wrapper-cnt">
                <div class="buttons-wrapper">
                    <template v-for="year in years">
                        <ButtonComponent v-if="year.visible"
                                         :key="year.id"
                                         :href="year.url"
                                         :text="year.label"
                        ></ButtonComponent>
                    </template>

                </div>
            </div>
        </section>
        <section class="carta-del-mulino-story">
            <div class="wide-content-wrapper-cnt">
                <h1 class="carta-del-mulino-story__title">3 Anni della <br>Carta del Mulino</h1>

                <div class="carta-del-mulino-story__wrapper-boxes">
                    <div class="carta-del-mulino-story__box">
                        <div class="carta-del-mulino-story__box-title">Cos'è</div>
                        <div class="carta-del-mulino-story__box-description">Un’innovativo disciplinare di agricoltura
                            sostenibile dedicato al grano tenero con 10 regole stilate da Mulino Bianco con WWF Italia
                        </div>
                    </div>
                    <div class="carta-del-mulino-story__box">
                        <div class="carta-del-mulino-story__box-title">Tra gli impegni</div>
                        <div class="carta-del-mulino-story__box-description">Destinare il 3% dei campi di grano tenero
                            (pari a 2500 campi da calcio) ai fiori da impollinazione
                        </div>
                    </div>
                </div>

                <div class="image-text-box-container">
                    <ImageTextBox
                            v-for="box in boxes"
                            :key="box.id"
                            :image-path="box.imagePath"
                            :title="box.title"
                            :description="box.description"
                            :title-before="box.titleBefore"
                    ></ImageTextBox>
                </div>
            </div>
        </section>
        <section class="carta-del-mulino-last-winner">
            <div class="wide-content-wrapper-cnt">
                <div class="carta-del-mulino-last-winner__image">
                    <img :src="require('../../assets/contest/2025/92506.jpg')" alt="Contest">
                </div>
                <div class="carta-del-mulino-last-winner__title">I fiori del Mulino</div>
                <div class="carta-del-mulino-last-winner__subtitle">Contest per il più bel campo fiorito del 2025</div>
                <div class="carta-del-mulino-last-winner__claim">2600 aziende agricole hanno dedicato il 3% dei<br>campi
                    di grano tenero alla coltivazione di fiori.
                </div>
                <div class="carta-del-mulino-last-winner__label">Il campo più bello è dell’Azienda<br>Agricola Spalletti
                </div>

            </div>
        </section>
    </main>
    <FooterComponent type="homepage"></FooterComponent>
</div>